/**
 * Touch has no hover, so a tap on the locked control's wrapper opens its
 * reason. Radix closes a tooltip on the trigger's click, which follows the
 * opening tap; closes inside this window are that click, not the user.
 */
export const TAP_OPEN_CLOSE_GRACE_MS = 400;

/** Mouse keeps Radix hover; touch and pen toggle on tap. */
export function isTapPointer(pointerType: string): boolean {
  return pointerType !== "mouse";
}

/** Tap releases: open unless the tap started on an open hint (Radix closed it). */
export function shouldOpenOnTapRelease(args: {
  readonly pointerType: string;
  readonly wasOpenOnPress: boolean;
}): boolean {
  return isTapPointer(args.pointerType) && !args.wasOpenOnPress;
}

/** Drop Radix's close from the opening tap's own click. */
export function shouldIgnoreClose(args: {
  readonly nextOpen: boolean;
  readonly now: number;
  readonly openedByTapAt: number | null;
}): boolean {
  if (args.nextOpen || args.openedByTapAt === null) return false;
  return args.now - args.openedByTapAt < TAP_OPEN_CLOSE_GRACE_MS;
}
